module.exports = __webpack_public_path__ + "media/Live Culture 宣傳影片.a1309d25.mp4";